import styled from "styled-components";
import { Input } from "antd";

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  // justify-content: space-between;

  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`;
export const FilterRow2 = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: space-between;

  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`;
export const TitleHistory = styled.span`
  color: #000;
  font-family: Manrope;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 56px; /* 186.667% */
  letter-spacing: -1.2px;
  text-transform: capitalize;
  @media screen and (max-width: 1024px) {
    & {
      margin-top: 24px;
      width: 100%;
      text-align: center;
      display: inline-block;
      color: #000;
      font-family: Manrope;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%; /* 30px */
      letter-spacing: -0.8px;
      text-transform: capitalize;
    }
  }
`;

export const FilterRowItem2 = styled.div`
  width: 452px;

  @media screen and (max-width: 1024px) {
    & {
      width: 100%;
    }

    & .ant-form-item-row {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
      justify-content: flex-start !important;
    }

    & .ant-form-item .ant-form-item-label {
      display: inline-flex !important;
      flex: none !important;
      padding: 0 !important;
      width: 100px !important;
      margin-right: 6px !important;
    }

    & .ant-form-item .ant-form-item-control {
      flex: 1 !important;
    }

    & .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      height: 40px !important;
      padding-left: 18px !important;
    }

    & .ant-select-single .ant-select-selector .ant-select-selection-item,
    &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      line-height: 40px !important;
    }
  }
`;
export const FilterRowItem = styled.div`
  width: calc(25%);
  &.mr-20 {
    width: calc(25% - 20px);
  }

  @media screen and (max-width: 1024px) {
    & {
      width: 100%;
    }

    & .ant-form-item-row {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
      justify-content: flex-start !important;
    }

    & .ant-form-item .ant-form-item-label {
      display: inline-flex !important;
      flex: none !important;
      padding: 0 !important;
      width: 100px !important;
      margin-right: 6px !important;
    }

    & .ant-form-item .ant-form-item-control {
      flex: 1 !important;
    }

    & .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      height: 40px !important;
      padding-left: 18px !important;
    }

    & .ant-select-single .ant-select-selector .ant-select-selection-item,
    &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      line-height: 40px !important;
    }
  }
`;

export const MSearchBottom = styled.div`
  margin-top: -85px;
  position: relative;
  background-color: white;
  height: 50px;
  z-index: 1;
  margin-left: -24px;
  margin-bottom: 12px;
`;
export const MSearchHead = styled.div`
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  width: 100%;
  padding-top: 30px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 2;
  padding-left: 22px;
  padding-right: 22px;
  padding-bottom: 22px;
`;
export const MSearchHeadIcon = styled.div``;
export const MSearchHeadInput = styled(Input)`
  flex: 1;
  border: none !important;
  box-shadow: none !important;
`;
export const MSearchHeadInputClear = styled.div`
  margin-right: 14px;
`;
export const MSearchHeadCancel = styled.div`
  height: 35px;
  background: linear-gradient(157.48deg, #ffffff -5.34%, #ffffff 103.65%);
  box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
  border-radius: 8px;
  font-weight: 700;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  color: #485ea8;
  width: 90px;
`;

export const OptionTypeTransaction = styled.div`
  position: relative;
  &.showOver {
    &::before {
      content: "";
      position: absolute;
      pointer-events: none;
      z-index: 10;
      width: 81px;
      height: 77px;
      right: -6px;
      bottom: -15px;
      background: linear-gradient(
        270deg,
        #f5f5f5 20.8%,
        rgba(245, 245, 245, 0) 113.61%
      );
    }
  }
`;

export const OptionTypeItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #ffffff;
  border-radius: 24.31px;
  height: 35px;
  cursor: pointer;

  font-weight: 500;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  text-transform: capitalize;
  color: #000000;
  &.checked {
    color: #ffffff;
    background-color: #000000;
  }
`;
export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
      stroke="#A3A3A3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 17.5L13.875 13.875"
      stroke="#A3A3A3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ClearSearchIcon = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1302_7135)">
      <path
        d="M10.0003 18.3337C14.6027 18.3337 18.3337 14.6027 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 14.6027 5.39795 18.3337 10.0003 18.3337Z"
        stroke="#A3A3A3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7.5L7.5 12.5"
        stroke="#A3A3A3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 7.5L12.5 12.5"
        stroke="#A3A3A3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1302_7135">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
